<template>
  <sub-page title="劳动人事争议调解申请">
    <div class="mediation-page">
      <!-- 申请人信息 -->
      <div class="section-title">申请人信息</div>
      <div class="form-card">
        <div class="field-row">
          <span class="field-label required">姓名</span>
          <input class="field-input" type="text" placeholder="请输入申请人姓名" v-model.trim="form.applicant" maxlength="20" />
        </div>
        <div class="field-row">
          <span class="field-label required">证件号码</span>
          <input class="field-input" type="text" placeholder="请输入身份证号码" v-model.trim="form.idNo" maxlength="18" />
        </div>
        <div class="field-row">
          <span class="field-label required">联系电话</span>
          <input class="field-input" type="tel" placeholder="请输入手机号码" v-model.trim="form.phone" maxlength="11" />
        </div>
      </div>

      <!-- 被申请人信息 -->
      <div class="section-title">被申请人信息</div>
      <div class="form-card">
        <div class="field-row">
          <span class="field-label required">单位名称</span>
          <input class="field-input" type="text" placeholder="请输入用人单位全称" v-model.trim="form.company" maxlength="60" />
        </div>
        <div class="field-row">
          <span class="field-label">单位地址</span>
          <input class="field-input" type="text" placeholder="请输入单位所在地址" v-model.trim="form.address" maxlength="80" />
        </div>
      </div>

      <!-- 申请内容 -->
      <div class="section-title">申请内容</div>
      <div class="form-card">
        <div class="field-row">
          <span class="field-label required">争议发生地</span>
          <input class="field-input" type="text" placeholder="如：南京市江北新区" v-model.trim="form.place" maxlength="40" />
        </div>
        <div class="field-block">
          <span class="field-label required">调解请求</span>
          <textarea class="field-area" rows="3" placeholder="请输入您请求调解的具体事项，如：请求支付拖欠工资、经济补偿等" v-model.trim="form.request"></textarea>
        </div>
        <div class="field-block">
          <span class="field-label">事实与理由</span>
          <textarea class="field-area" rows="4" placeholder="请简述争议发生的时间、经过及相关情况（选填）" v-model.trim="form.reason"></textarea>
        </div>
      </div>

      <!-- 证据材料 -->
      <div class="section-title">证据材料（选填）</div>
      <div class="form-card">
        <div class="upload-row" @click="pickFile">
          <svg viewBox="0 0 24 24" class="upload-icon">
            <path d="M12 16 V5 M7.5 9.5 L12 5 l4.5 4.5" fill="none" stroke="#2E8CF6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M4.5 16.5 v2 A1.5 1.5 0 0 0 6 20 h12 a1.5 1.5 0 0 0 1.5-1.5 v-2" fill="none" stroke="#2E8CF6" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <span class="upload-text">点击上传劳动合同、工资记录等材料</span>
        </div>
        <div class="file-item" v-for="(f, i) in files" :key="i">
          <span class="file-name">{{ f }}</span>
          <svg viewBox="0 0 24 24" class="file-del" @click="files.splice(i, 1)">
            <path d="M7 7 L17 17 M17 7 L7 17" fill="none" stroke="#c8c9cc" stroke-width="2.2" stroke-linecap="round"/>
          </svg>
        </div>
        <input ref="fileInput" type="file" class="file-hidden" multiple @change="onFileChange" />
      </div>

      <!-- 提交 -->
      <div class="btn-bar">
        <button class="submit-btn" @click="submit">提交申请</button>
      </div>

      <!-- 操作说明 -->
      <div class="op-note">
        <p>操作说明：</p>
        <p>1.发生劳动人事争议后，可向用人单位所在地或劳动合同履行地的调解组织申请调解。</p>
        <p>2.提交申请后请保持电话畅通，调解组织将在5个工作日内与您联系。</p>
        <p>3.调解不成的，可依法向劳动人事争议仲裁委员会申请仲裁。</p>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'LaborDisputeMediation',
  components: { SubPage },
  data() {
    return {
      form: {
        applicant: '',
        idNo: '',
        phone: '',
        company: '',
        address: '',
        place: '',
        request: '',
        reason: ''
      },
      files: []
    }
  },
  methods: {
    pickFile() {
      this.$refs.fileInput.click()
    },
    onFileChange(e) {
      const list = Array.from(e.target.files || [])
      list.forEach(f => this.files.push(f.name))
      e.target.value = ''
    },
    submit() {
      if (!this.form.applicant) { this.$alert('请输入申请人姓名'); return }
      if (!/^\d{17}[\dXx]$/.test(this.form.idNo)) { this.$alert('请输入正确的身份证号码'); return }
      if (!/^1[3-9]\d{9}$/.test(this.form.phone)) { this.$alert('请输入正确的手机号码'); return }
      if (!this.form.company) { this.$alert('请输入用人单位全称'); return }
      if (!this.form.place) { this.$alert('请输入争议发生地'); return }
      if (!this.form.request) { this.$alert('请输入调解请求'); return }
      this.$alert('调解申请已提交，请保持电话畅通，调解组织将与您联系')
    }
  }
}
</script>

<style scoped>
.mediation-page {
  background: #F3F8FB;
  min-height: 100%;
  padding-bottom: calc(60 * var(--w));
}
.section-title {
  margin: calc(36 * var(--w)) calc(32 * var(--w)) calc(16 * var(--w));
  font-size: calc(34 * var(--w));
  font-weight: 500;
  color: #323233;
}
.form-card {
  background: #fff;
  margin: 0 calc(24 * var(--w));
  border-radius: calc(16 * var(--w));
  overflow: hidden;
}
.field-row {
  display: flex;
  align-items: center;
  height: calc(110 * var(--w));
  padding: 0 calc(32 * var(--w));
  border-bottom: 1px solid #f0f0f0;
}
.field-row:last-child {
  border-bottom: none;
}
.field-label {
  font-size: calc(32 * var(--w));
  color: #323233;
  white-space: nowrap;
  width: calc(200 * var(--w));
  flex-shrink: 0;
}
.field-label.required::before {
  content: '*';
  color: #f56c6c;
  margin-right: calc(4 * var(--w));
}
.field-input {
  flex: 1;
  height: 100%;
  border: none;
  outline: none;
  font-size: calc(32 * var(--w));
  color: #323233;
  background: transparent;
  font-family: inherit;
}
.field-input::placeholder {
  color: #969799;
}
.field-block {
  padding: calc(28 * var(--w)) calc(32 * var(--w));
  border-bottom: 1px solid #f0f0f0;
}
.field-block .field-label {
  width: auto;
  display: block;
}
.field-area {
  margin-top: calc(20 * var(--w));
  width: 100%;
  border: none;
  outline: none;
  resize: none;
  font-size: calc(32 * var(--w));
  color: #323233;
  line-height: 1.5;
  font-family: inherit;
  background: #F8F9FB;
  border-radius: calc(8 * var(--w));
  padding: calc(20 * var(--w));
  box-sizing: border-box;
}
.field-area::placeholder {
  color: #969799;
}
.upload-row {
  display: flex;
  align-items: center;
  padding: calc(30 * var(--w)) calc(32 * var(--w));
  cursor: pointer;
}
.upload-icon {
  width: calc(44 * var(--w));
  height: calc(44 * var(--w));
  flex-shrink: 0;
}
.upload-text {
  margin-left: calc(20 * var(--w));
  font-size: calc(30 * var(--w));
  color: #2E8CF6;
}
.file-item {
  display: flex;
  align-items: center;
  padding: calc(20 * var(--w)) calc(32 * var(--w));
  border-top: 1px solid #f5f5f5;
}
.file-name {
  flex: 1;
  font-size: calc(30 * var(--w));
  color: #323233;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.file-del {
  width: calc(32 * var(--w));
  height: calc(32 * var(--w));
  flex-shrink: 0;
  cursor: pointer;
}
.file-hidden {
  display: none;
}
.btn-bar {
  padding: calc(56 * var(--w)) calc(32 * var(--w)) 0;
}
.submit-btn {
  width: 100%;
  height: calc(96 * var(--w));
  background: #2E8CF6;
  color: #fff;
  font-size: calc(38 * var(--w));
  border: none;
  border-radius: calc(48 * var(--w));
  cursor: pointer;
  font-family: inherit;
}
.submit-btn:active {
  background: #2578DB;
}
.op-note {
  margin: calc(40 * var(--w)) calc(32 * var(--w)) 0;
}
.op-note p {
  margin: 0;
  font-size: calc(28 * var(--w));
  color: #969799;
  line-height: 1.8;
}
</style>



// WEBPACK FOOTER //
// src/pages/LaborDisputeMediation.vue